unit UReportListForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UFakModel, UContentList,
  UWebReportUtils, WEBLib.Buttons, Types, Vcl.Grids, WEBLib.Grids;

type
  TReportListForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlButtons: TPanel;
    btnRepAppend: TBitBtn;
    pnlReportList: TPanel;
    sgReportList: TStringGrid;
    btnRepEdit: TBitBtn;
    btnRepDelete: TBitBtn;
    btnRepView: TBitBtn;
    btnLoad: TBitBtn;
    btnRepDownload: TBitBtn;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    [Async]
    procedure btnRepAppendClick(Sender: TObject); async;
    procedure WebFormCreate(Sender: TObject);
    procedure sgReportListSelectCell(Sender: TObject; ACol, ARow: Integer;
      var CanSelect: Boolean);
    [Async]
    procedure btnRepEditClick(Sender: TObject); async;
    procedure btnRepDeleteClick(Sender: TObject);
    procedure sgReportListDblClick(Sender: TObject);
    [Async]
    procedure btnRepViewClick(Sender: TObject); async;
    procedure btnLoadClick(Sender: TObject);
    procedure btnRepDownloadClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FFak: TFakModel;
    FReportList: TReportList;
    FContentList: TContentList;
    FButtonsEnabled: Boolean;
    [Async]
    procedure HandleListLoaded(Sender: TObject); async;
    procedure HandleError(Sender: TObject; AMsg: string);
    procedure HandlePropertyChanged(Sender: TObject; PropertyName: string);
    procedure SgReportListFill(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFak(const Value: TFakModel);
    procedure SetReportlist(const Value: TReportList);
    procedure SetContentList(const Value: TContentList);
    procedure SetButtonsEnabled(const Value: Boolean);
  public
    procedure EnableButtons(Value: Boolean);
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Fak: TFakModel read FFak write SetFak;
    property ReportList: TReportList read FReportList write SetReportlist;
    property ContentList: TContentList read FContentList write SetContentList;
    property ButtonsEnabled: Boolean read FButtonsEnabled
      write SetButtonsEnabled;
  protected procedure LoadDFMValues; override; end;

var
  ReportListForm: TReportListForm;

implementation

uses
  UEssentialHelper, UReportForm, Math, UWebHtml2Pdf, UReportShowForm,
  WEBLib.LocalFiles, UUserModel, WEBLib.Utils;

{$R *.dfm}

procedure TReportListForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TReportListForm.btnLoadClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.ContentList.Clear;
  Self.ContentList.GetContent(Self.MainConfig.Uri, Self.Fak.Nr);
end;

procedure TReportListForm.btnRepAppendClick(Sender: TObject);
var
  frm: TReportForm;
  rep: TReport;
  guid: TGuId;
begin
  Self.MainConfig.TimerReset;
  if (Self.Fak <> nil) and (Self.Fak.Nr <> '') then
  begin
    frm := TReportForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TReportForm, frm.Load);
    frm.MainConfig := Self.MainConfig;
    rep := TReport.Create;
    CreateGUID(guid);
    rep.Name := GUIDToString(guid);
    rep.User := Self.MainConfig.User;
    rep.Fak := Self.Fak;
    rep.Datum := Date;
    rep.ReportItemList.OnListChanged := frm.SgReportItemListFill;
    rep.ReportItemList.OnListError := frm.HandleListError;
    rep.ReportItemList.OnPropertyChanged := frm.HandlePropertyChanged;
    Self.ReportList.Add(rep);
    frm.Report := rep;
    frm.EnableButtons(false);
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.WebFormResize(Self);
      Self.Show;
    end;
  end;
end;

procedure TReportListForm.btnRepDeleteClick(Sender: TObject);
var
  s: string;
  procedure HandleResult(Result: TModalResult);
  var
    index: Integer;
  begin
    if Result = mrYes then
    begin
      index := Self.ReportList.IndexOf(Self.ReportList.SelectedItem);
      if index >= 0 then
        Self.ReportList.Delete(index);
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  if (Self.ReportList.SelectedItem <> nil) and
    (Self.ReportList.SelectedItem.TransmittedAt = 0) then
  begin
    s := 'Möchten Sie den ' + Self.ReportList.SelectedItem.ToString + #13#10;
    s := s + 'jetzt löschen ?';
    MessageDLG(s, mtConfirmation, [mbYes, mbNo], @HandleResult);
  end;
end;

procedure TReportListForm.btnRepDownloadClick(Sender: TObject);
var
  tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  var
    s: string;
    p: Integer;
    bFile: TBinaryFile;
  begin
    if Sender is TTextFile then
    begin
      with Sender as TTextFile do
      begin
        s := Text;
        p := Pos('base64,', s);
        if p > 0 then
          Delete(s, 1, p + Length('base64,') - 1);
        bFile := TBinaryFile.Create(nil);
        bFile.Data := Base64ToArrayBuffer(s);
        bFile.SaveAsFile;
      end;
    end;
  end;

begin
  if Self.ReportList.SelectedItem <> nil then
  begin
    tFile := TTextFile.Create(nil);
    tFile.OnFileOpen := HandleFileOpen;
    tFile.OpenFile(Self.ReportList.SelectedItem.PdfPathname,
      Self.ReportList.SelectedItem.PdfFilename);
  end;
end;

procedure TReportListForm.btnRepEditClick(Sender: TObject);
var
  frm: TReportForm;
begin
  Self.MainConfig.TimerReset;
  if Self.ReportList.SelectedItem <> nil then
  begin
    frm := TReportForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TReportForm, frm.Load);
    frm.MainConfig := Self.MainConfig;
    frm.Report := Self.ReportList.SelectedItem;
    frm.Report.ReportItemList.OnListChanged := frm.SgReportItemListFill;
    frm.Report.ReportItemList.OnListError := frm.HandleListError;
    frm.Report.ReportItemList.OnPropertyChanged := frm.HandlePropertyChanged;
    frm.EnableButtons(true);
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      frm.Free;
      Self.Show;
      Self.WebFormResize(Self);
    end;
  end;
end;

procedure TReportListForm.btnRepViewClick(Sender: TObject);
var
  frm: TReportShowForm;
begin
  Self.MainConfig.TimerReset;
  if (Self.ReportList.SelectedItem <> nil) and Self.ReportList.SelectedItem.PdfFileExists
  then
  begin
    frm := TReportShowForm.Create(Self);
    frm.Caption := Self.Caption;
    frm.Popup := false;
    await(TReportShowForm, frm.Load);
    frm.MainConfig := Self.MainConfig;
    frm.Report := Self.ReportList.SelectedItem;
    try
      Self.Hide;
      await(TModalResult, frm.Execute);
    finally
      Self.Show;
      Self.WebFormResize(Sender);
      frm.Hide;
      frm.Free;
    end;
  end;
end;

procedure TReportListForm.EnableButtons(Value: Boolean);
begin
  btnRepAppend.Visible := Value;
  btnRepEdit.Visible := Value;
  btnRepDelete.Visible := Value;
  btnRepView.Visible := Value;
  btnRepDownload.Visible := Value;
end;

procedure TReportListForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtWarning, [mbOK], nil);
end;

procedure TReportListForm.HandleListLoaded(Sender: TObject);
var
  i: Integer;
  cItem: TContentModel;
  rItem: TReport;
  t: TTextFile;
  dummy: TCallback;
  procedure HandleGetData(Sender: TObject);
  var
    cModel: TContentModel;
    rModel: TReport;
    s: string;
  begin
    if Sender is TContentModel then
    begin
      cModel := Sender as TContentModel;
      rModel := TReport.Create;
      rModel.OnPropertyChanged := Self.HandlePropertyChanged;
      rModel.Fak := TFakModel.Create;
      rModel.Fak.Nr := cModel.FakNr;
      rModel.PdfFilename := cModel.Filename;
      rModel.PdfPathname := cModel.FakNr + '\Pdfs';
      rModel.CreatedAt := cModel.Created;
      rModel.TransmittedAt := cModel.Received;
      rModel.User := TUserModel.Create;
      rModel.User.Name := cModel.Name;
      rModel.User.Vorname := cModel.Vorname;
      rModel.Datum := cModel.Datum;
      s := cModel.Filename;
      Delete(s, Length(s) - 3, 4);
      s := '{' + s + '}';
      rModel.Name := s;
      Self.ReportList.Add(rModel);
    end;
  end;

[Async]
  procedure HandleFileExists(Sender: TObject; AValue: Boolean); async;
  begin
    if not AValue then
    begin
      cItem.OnGetData := HandleGetData;
      cItem.OnError := Self.HandleError;
      await(cItem.GetData(Self.MainConfig.Uri));
    end;
  end;

begin
  if Sender is TContentList then
  begin
    Self.ContentList := Sender as TContentList;
    dummy := Self.ReportList.OnListChanged;
    Self.ReportList.OnListChanged := nil;
    for i := 0 to Self.ContentList.Count - 1 do
    begin
      cItem := Self.ContentList.Items[i];
      if cItem.Kind = akPdf then
      begin
        rItem := Self.ReportList.GetByPathAndFilename(cItem.FakNr + '\Pdfs',
          cItem.Filename);
        if rItem = nil then
        begin
          cItem.OnGetData := HandleGetData;
          cItem.OnError := Self.HandleError;
          await(cItem.GetData(Self.MainConfig.Uri));
        end
        else
        begin
          t := TTextFile.Create(nil);
          t.OnFileExists := HandleFileExists;
          await(t.FileExists(Self.Fak.Nr + '\Pdfs', cItem.Filename));
        end;
      end;
    end;
    Self.ReportList.OnListChanged := dummy;
    Self.SgReportListFill(nil);
  end;
end;

procedure TReportListForm.HandlePropertyChanged(Sender: TObject;
  PropertyName: string);
begin
  if (PropertyName = 'SelectedItem') or (PropertyName = 'PdfFileExists') then
  begin
    btnRepDelete.Visible := Self.ButtonsEnabled and
      (Self.ReportList.SelectedItem <> nil) and
      (Self.ReportList.SelectedItem.TransmittedAt = 0) and
      not Self.ReportList.SelectedItem.PdfFileExists;
    btnRepEdit.Visible := btnRepDelete.Visible;
    btnRepView.Visible := (Self.ReportList.SelectedItem <> nil) and
      Self.ReportList.SelectedItem.PdfFileExists;
    btnRepDownload.Visible := btnRepView.Visible;
  end;
  if PropertyName = 'PdfFileExists' then
    Self.SgReportListFill(Sender);
end;

procedure TReportListForm.SetContentList(const Value: TContentList);
begin
  FContentList := Value;
end;

procedure TReportListForm.SetFak(const Value: TFakModel);
begin
  FFak := Value;
  Self.ReportList := TReportList.Create;
  Self.ReportList.PersonalNr := Self.MainConfig.User.PersonalNr;
  Self.ReportList.Fak := Self.Fak;
  Self.ReportList.OnListChanged := Self.SgReportListFill;
  Self.ReportList.OnListError := Self.HandleError;
  Self.ReportList.OnPropertyChanged := Self.HandlePropertyChanged;
  Self.ReportList.Load;
end;

procedure TReportListForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TReportListForm.SetReportlist(const Value: TReportList);
begin
  FReportList := Value;
end;

procedure TReportListForm.sgReportListDblClick(Sender: TObject);
begin
  if btnRepEdit.Visible then
    Self.btnRepEditClick(Sender)
  else if btnRepView.Visible then
    Self.btnRepViewClick(Sender);
end;

procedure TReportListForm.SgReportListFill(Sender: TObject);
var
  i: Integer;
  item: TReport;
begin
  sgReportList.DefaultRowHeight := 32;
  sgReportList.ColCount := 6;
  sgReportList.RowCount := Max(2, Self.ReportList.Count + 1);
  sgReportList.FixedCols := 0;
  sgReportList.FixedRows := 1;
  sgReportList.Cells[3, 0] := Bold('Bericht vom...');
  sgReportList.Cells[4, 0] := Bold('Author');
  sgReportList.Cells[5, 0] := Bold('erstellt am');
  sgReportList.ColWidths[0] := 5;
  sgReportList.ColWidths[1] := 16;
  sgReportList.ColWidths[2] := 16;
  sgReportList.ColWidths[3] := 140;
  sgReportList.ColWidths[4] := 140;
  sgReportList.ColWidths[5] := 140;
  for i := 0 to sgReportList.ColCount - 1 do
    sgReportList.Cells[i, 1] := '';
  for i := 0 to Self.ReportList.Count - 1 do
  begin
    item := Self.ReportList.Items[i];
    if item.TransmittedAt > 0 then
      sgReportList.Cells[1, i + 1] :=
        '<img src="Images\IconOk.png" style="width:16px;height:16px;">'
    else
      sgReportList.Cells[1, i + 1] := '';
    if item.PdfFileExists then
      sgReportList.Cells[2, i + 1] :=
        '<img src="Images\IconPdf.png" style="width:16px;height:16px;">'
    else
      sgReportList.Cells[2, i + 1] := '';

    sgReportList.Cells[3, i + 1] := FormatDateTime('ddd. dd.mm.yyyy',
      item.Datum);
    sgReportList.Cells[4, i + 1] := item.User.ToString;
    sgReportList.Cells[5, i + 1] := FormatDateTime('dd.mm.yyyy hh:nn',
      item.CreatedAt);
  end;
end;

procedure TReportListForm.sgReportListSelectCell(Sender: TObject;
  ACol, ARow: Integer; var CanSelect: Boolean);
begin
  if (0 < ARow) and (ARow <= Self.ReportList.Count) then
    Self.ReportList.SelectedItem := Self.ReportList.Items[ARow - 1]
  else
    Self.ReportList.SelectedItem := nil;
end;

procedure TReportListForm.WebFormCreate(Sender: TObject);
begin
  Self.ReportList := nil;
  Self.ContentList := TContentList.Create;
  Self.ContentList.OnError := Self.HandleError;
  Self.ContentList.OnLoaded := Self.HandleListLoaded;
end;

procedure TReportListForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TReportListForm.WebFormResize(Sender: TObject);
var
  l: Integer;
begin
  pnlButtons.Top := pnlHeader.Top + pnlHeader.Height;
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Berichte';
    pnlReportList.Top := pnlButtons.Top + pnlButtons.Height;
    pnlReportList.Height := Self.ClientHeight - pnlHeader.Height -
      pnlButtons.Height;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Berichte';
    pnlReportList.Top := pnlButtons.Top + pnlButtons.Height;
    pnlReportList.Height := Self.ClientHeight - pnlHeader.Height -
      pnlButtons.Height - pnlFooter.Height;;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  pnlButtons.Width := Min(535, Self.ClientWidth);
  pnlReportList.Width := pnlButtons.Width;
  l := (Self.ClientWidth - pnlButtons.Width) div 2;
  if l < 0 then
    l := 0;
  pnlButtons.Left := l;
  pnlReportList.Left := pnlButtons.Left;
  if btnRepAppend.Visible then
  begin
    btnRepView.Left := btnRepEdit.Left;
    btnRepDownload.Left := btnRepDelete.Left;
  end
  else
  begin
    btnRepView.Left := btnRepAppend.Left;
    btnRepDownload.Left := btnRepEdit.Left;
  end;
  btnLoad.Left := pnlButtons.ClientWidth - btnLoad.Width - 6;
end;

procedure TReportListForm.SetButtonsEnabled(const Value: Boolean);
begin
  FButtonsEnabled := Value;
  Self.EnableButtons(Value);
end;

procedure TReportListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlButtons := TPanel.Create(Self);
  btnRepAppend := TBitBtn.Create(Self);
  btnRepEdit := TBitBtn.Create(Self);
  btnRepDelete := TBitBtn.Create(Self);
  btnRepView := TBitBtn.Create(Self);
  btnLoad := TBitBtn.Create(Self);
  btnRepDownload := TBitBtn.Create(Self);
  pnlReportList := TPanel.Create(Self);
  sgReportList := TStringGrid.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlButtons.BeforeLoadDFMValues;
  btnRepAppend.BeforeLoadDFMValues;
  btnRepEdit.BeforeLoadDFMValues;
  btnRepDelete.BeforeLoadDFMValues;
  btnRepView.BeforeLoadDFMValues;
  btnLoad.BeforeLoadDFMValues;
  btnRepDownload.BeforeLoadDFMValues;
  pnlReportList.BeforeLoadDFMValues;
  sgReportList.BeforeLoadDFMValues;
  try
    Name := 'ReportListForm';
    Width := 640;
    Height := 480;
    Caption := 'Berichte';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UReportListForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Berichte';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UReportListForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlButtons.SetParentComponent(Self);
    pnlButtons.Name := 'pnlButtons';
    pnlButtons.Left := 0;
    pnlButtons.Top := 64;
    pnlButtons.Width := 640;
    pnlButtons.Height := 48;
    pnlButtons.Caption := 'pnlButtons';
    pnlButtons.ChildOrder := 2;
    pnlButtons.ShowCaption := False;
    btnRepAppend.SetParentComponent(pnlButtons);
    btnRepAppend.Name := 'btnRepAppend';
    btnRepAppend.Left := 4;
    btnRepAppend.Top := 4;
    btnRepAppend.Width := 40;
    btnRepAppend.Height := 40;
    btnRepAppend.Hint := 'Neuen Bericht erstellen';
    btnRepAppend.Color := clNone;
    btnRepAppend.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnRepAppend.Glyph.png');
    btnRepAppend.GlyphSize := 32;
    btnRepAppend.HeightPercent := 100.000000000000000000;
    btnRepAppend.ShowHint := True;
    btnRepAppend.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepAppend, Self, 'OnClick', 'btnRepAppendClick');
    btnRepEdit.SetParentComponent(pnlButtons);
    btnRepEdit.Name := 'btnRepEdit';
    btnRepEdit.Left := 48;
    btnRepEdit.Top := 4;
    btnRepEdit.Width := 40;
    btnRepEdit.Height := 40;
    btnRepEdit.Hint := 'Bericht bearbeiten';
    btnRepEdit.Color := clNone;
    btnRepEdit.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnRepEdit.Glyph.png');
    btnRepEdit.GlyphSize := 32;
    btnRepEdit.HeightPercent := 100.000000000000000000;
    btnRepEdit.ShowHint := True;
    btnRepEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepEdit, Self, 'OnClick', 'btnRepEditClick');
    btnRepDelete.SetParentComponent(pnlButtons);
    btnRepDelete.Name := 'btnRepDelete';
    btnRepDelete.Left := 92;
    btnRepDelete.Top := 4;
    btnRepDelete.Width := 40;
    btnRepDelete.Height := 40;
    btnRepDelete.Hint := 'Bericht l'#246'schen';
    btnRepDelete.Color := clNone;
    btnRepDelete.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnRepDelete.Glyph.png');
    btnRepDelete.GlyphSize := 32;
    btnRepDelete.HeightPercent := 100.000000000000000000;
    btnRepDelete.ShowHint := True;
    btnRepDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepDelete, Self, 'OnClick', 'btnRepDeleteClick');
    btnRepView.SetParentComponent(pnlButtons);
    btnRepView.Name := 'btnRepView';
    btnRepView.Left := 136;
    btnRepView.Top := 4;
    btnRepView.Width := 40;
    btnRepView.Height := 40;
    btnRepView.Hint := 'Bericht anzeigen';
    btnRepView.Color := clNone;
    btnRepView.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnRepView.Glyph.png');
    btnRepView.GlyphSize := 32;
    btnRepView.HeightPercent := 100.000000000000000000;
    btnRepView.ShowHint := True;
    btnRepView.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepView, Self, 'OnClick', 'btnRepViewClick');
    btnLoad.SetParentComponent(pnlButtons);
    btnLoad.Name := 'btnLoad';
    btnLoad.Left := 580;
    btnLoad.Top := 4;
    btnLoad.Width := 40;
    btnLoad.Height := 40;
    btnLoad.Hint := 'Liste aktualisieren';
    btnLoad.Color := clNone;
    btnLoad.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnLoad.Glyph.png');
    btnLoad.GlyphSize := 32;
    btnLoad.HeightPercent := 100.000000000000000000;
    btnLoad.ShowHint := True;
    btnLoad.WidthPercent := 100.000000000000000000;
    SetEvent(btnLoad, Self, 'OnClick', 'btnLoadClick');
    btnRepDownload.SetParentComponent(pnlButtons);
    btnRepDownload.Name := 'btnRepDownload';
    btnRepDownload.Left := 180;
    btnRepDownload.Top := 4;
    btnRepDownload.Width := 40;
    btnRepDownload.Height := 40;
    btnRepDownload.Hint := 'Bericht herunterladen';
    btnRepDownload.Color := clNone;
    btnRepDownload.Glyph.LoadFromFile('UReportListForm.pnlButtons.btnRepDownload.Glyph.png');
    btnRepDownload.GlyphSize := 32;
    btnRepDownload.HeightPercent := 100.000000000000000000;
    btnRepDownload.ShowHint := True;
    btnRepDownload.WidthPercent := 100.000000000000000000;
    SetEvent(btnRepDownload, Self, 'OnClick', 'btnRepDownloadClick');
    pnlReportList.SetParentComponent(Self);
    pnlReportList.Name := 'pnlReportList';
    pnlReportList.Left := 0;
    pnlReportList.Top := 112;
    pnlReportList.Width := 640;
    pnlReportList.Height := 344;
    pnlReportList.Caption := 'pnlReportList';
    pnlReportList.ChildOrder := 3;
    pnlReportList.ShowCaption := False;
    sgReportList.SetParentComponent(pnlReportList);
    sgReportList.Name := 'sgReportList';
    sgReportList.Left := 0;
    sgReportList.Top := 0;
    sgReportList.Width := 640;
    sgReportList.Height := 344;
    sgReportList.Align := alClient;
    sgReportList.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goColSizing,goRowSelect,goFixedRowDefAlign];
    sgReportList.TabOrder := 0;
    SetEvent(sgReportList, Self, 'OnDblClick', 'sgReportListDblClick');
    SetEvent(sgReportList, Self, 'OnSelectCell', 'sgReportListSelectCell');
    sgReportList.RangeEdit.Max := 100.000000000000000000;
    sgReportList.RangeEdit.Step := 1.000000000000000000;
    sgReportList.HeightPercent := 100.000000000000000000;
    sgReportList.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlButtons.AfterLoadDFMValues;
    btnRepAppend.AfterLoadDFMValues;
    btnRepEdit.AfterLoadDFMValues;
    btnRepDelete.AfterLoadDFMValues;
    btnRepView.AfterLoadDFMValues;
    btnLoad.AfterLoadDFMValues;
    btnRepDownload.AfterLoadDFMValues;
    pnlReportList.AfterLoadDFMValues;
    sgReportList.AfterLoadDFMValues;
  end;
end;

end.
